{
  "v3.projet.action.created": "created",
  "v3.projet.action.deleted": "deleted",
  "v3.projet.action.status_changed": "status changed",
  "v3.projet.action.updated": "updated",
  "v3.projet.actualiser": "Refresh",
  "v3.projet.annuler": "Cancel",
  "v3.projet.charte.appliquee": "Applied charter",
  "v3.projet.charte.aucune_surcharge": "No override requested.",
  "v3.projet.charte.aucune_validee": "No charter validated by the organisation.",
  "v3.projet.charte.demander": "Request an override",
  "v3.projet.charte.imposee": "Organisation charter enforced (version {{version}}).",
  "v3.projet.charte.recommandee": "Organisation charter recommended (version {{version}}).",
  "v3.projet.charte.retirer": "Withdraw the request",
  "v3.projet.charte.revenir": "Return to the organisation charter",
  "v3.projet.charte.revenir_effet": "The override ends; the organisation charter applies again.",
  "v3.projet.charte.revenir_verbe": "Return",
  "v3.projet.charte.statut.active": "Granted",
  "v3.projet.charte.statut.ended": "Ended",
  "v3.projet.charte.statut.refused": "Refused",
  "v3.projet.charte.statut.requested": "To be decided by the organisation",
  "v3.projet.charte.surcharge_accordee": "Project override granted: the project charter applies.",
  "v3.projet.charte.surcharges": "Requested overrides",
  "v3.projet.charte.titre": "Project charter",
  "v3.projet.choisir": "— Choose —",
  "v3.projet.code.ALREADY_EXISTS": "This identifier is already taken.",
  "v3.projet.code.CONFLIT_DE_VERSION": "The project was changed meanwhile: reload before saving.",
  "v3.projet.code.CONTEXTE_INCOMPLET": "The project context is incomplete: the rule cannot be evaluated.",
  "v3.projet.code.CORRESPONDANCE_PAQUET_REQUETE": "The package does not match the export request: download refused.",
  "v3.projet.code.CREATEUR_N_APPROUVE_PAS": "You are the author: someone else must decide.",
  "v3.projet.code.DESIGNATION_NON_MEMBRE": "This person is not a member of the project.",
  "v3.projet.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v3.projet.code.EXPORT_EXPIRE": "This export link has expired: request a new export.",
  "v3.projet.code.EXPORT_INTROUVABLE": "This export cannot be found.",
  "v3.projet.code.IDEMPOTENCE_CONFLIT": "This request was already sent with different content.",
  "v3.projet.code.INHERITED_REQUIREMENT_REMOVAL_REQUIRES_WAIVER": "An inherited rule cannot be removed: request a waiver.",
  "v3.projet.code.MODELE_V10_INCOHERENT": "The project's model is inconsistent: notify the organisation's administration.",
  "v3.projet.code.NOM_DEJA_PRIS": "This name is already used by another project of the organisation.",
  "v3.projet.code.NOT_FOUND": "This object cannot be found.",
  "v3.projet.code.PAQUET_NON_DISPONIBLE": "The package of this export is not available yet.",
  "v3.projet.code.PROPOSITION_CADUQUE": "This proposal was withdrawn or already answered.",
  "v3.projet.code.PROPRIETAIRE_NON_MEMBRE": "The rule owner must be a member of the project.",
  "v3.projet.code.PROPRIETAIRE_SEUL": "Only the project owner can do this.",
  "v3.projet.code.QUOTA_AU_DELA_DU_PLAFOND": "This limit exceeds the organisation ceiling.",
  "v3.projet.code.RATTACHEMENT_DEJA_AILLEURS": "The project is already attached to another programme.",
  "v3.projet.code.REQUIREMENT_CODE_EXISTS": "This identifier is already taken.",
  "v3.projet.code.REQUIREMENT_HAS_WAIVER_HISTORY": "This rule has waivers: it cannot be removed.",
  "v3.projet.code.RESOURCE_UNAVAILABLE": "This item is unavailable.",
  "v3.projet.code.ROLE_HORS_MODELE": "This role is not a designation of the project's model.",
  "v3.projet.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v3.projet.code.SUPPRESSION_DEJA_DEMANDEE": "Deletion of this project has already been requested.",
  "v3.projet.code.VALIDATION_ERROR": "An entered value was rejected: check the form.",
  "v3.projet.code.VERSION_CONFLICT": "The project was changed meanwhile: reload before saving.",
  "v3.projet.code.WAIVER_ALREADY_REVIEWED": "This waiver has already been reviewed.",
  "v3.projet.code.WAIVER_COMPENSATING_CONTROLS_REQUIRED": "At least one compensating control is required.",
  "v3.projet.code.WAIVER_EXPIRY_REQUIRED": "The expiry date is required.",
  "v3.projet.code.WAIVER_RISK_CANNOT_BE_LOWERED": "The severity cannot be lowered.",
  "v3.projet.code.WAIVER_SELF_REVIEW_REFUSED": "You requested this waiver: someone else must review it.",
  "v3.projet.code.WORKSPACE_ARCHIVED": "The project is archived: read-only.",
  "v3.projet.cycle.actif": "Active project.",
  "v3.projet.cycle.archive": "Archived project: read-only.",
  "v3.projet.cycle.archiver": "Archive the project",
  "v3.projet.cycle.archiver_effet": "The project becomes read-only for all its members.",
  "v3.projet.cycle.archiver_reversible": "Unarchiving reopens it.",
  "v3.projet.cycle.archiver_verbe": "Archive",
  "v3.projet.cycle.aucune_suppression": "No deletion requested.",
  "v3.projet.cycle.demander_suppression": "Request deletion",
  "v3.projet.cycle.desarchiver": "Unarchive the project",
  "v3.projet.cycle.etat": "Project state",
  "v3.projet.cycle.sollicitee": "Deletion requested on {{date}} by {{par}}: the organisation will decide.",
  "v3.projet.cycle.suppression": "Deletion",
  "v3.projet.cycle.transferer": "Transfer ownership",
  "v3.projet.derogation.deja": "already waived",
  "v3.projet.derogation.demander": "Request approval",
  "v3.projet.derogation.expire": "Expires on",
  "v3.projet.derogation.expire_validation": "The expiry must be in the future and within one year.",
  "v3.projet.derogation.gravite": "Severity level",
  "v3.projet.derogation.gravite_critical": "Critical",
  "v3.projet.derogation.gravite_high": "High",
  "v3.projet.derogation.gravite_low": "Low",
  "v3.projet.derogation.gravite_medium": "Medium",
  "v3.projet.derogation.justification": "Justification",
  "v3.projet.derogation.mesures": "Compensating controls (one per line)",
  "v3.projet.derogation.regle": "Targeted rule",
  "v3.projet.derogation.suite": "The waiver is reviewed in the project then decided by the organisation.",
  "v3.projet.derogation.titre": "Request a waiver",
  "v3.projet.designation.aucun_role": "No role to designate in this project.",
  "v3.projet.designation.designer": "Designate",
  "v3.projet.designation.exige_manquant": "{{role}} (required, missing)",
  "v3.projet.designation.journal": "The designation is written to the log.",
  "v3.projet.designation.personne": "Person",
  "v3.projet.designation.remplace": "Replaces the designation of {{qui}}; written to the log.",
  "v3.projet.designation.role": "Role",
  "v3.projet.designation.roles": "Project roles",
  "v3.projet.designation.titre": "Designate a person for a project role",
  "v3.projet.equipe.a_ajouter": "Member to add",
  "v3.projet.equipe.ajouter": "Add to the team",
  "v3.projet.equipe.assignes": "{{n}} assigned items",
  "v3.projet.equipe.aucun_membre": "No member in this team.",
  "v3.projet.equipe.aucun_travail": "No assigned work.",
  "v3.projet.equipe.capacite_jours": "{{n}} person-days",
  "v3.projet.equipe.capacite_points": "{{n}} points",
  "v3.projet.equipe.charge": "Cadence {{cadence}}: {{points}} points committed, capacity {{capacite}}.",
  "v3.projet.equipe.creer": "Create the team",
  "v3.projet.equipe.creer_titre": "Create a project team",
  "v3.projet.equipe.effet_membres": "{{n}} member(s) remain project members.",
  "v3.projet.equipe.effet_travail": "The work assigned to “{{nom}}” ({{n}} items) stays in the project, without a team.",
  "v3.projet.equipe.fiche": "Project team — details",
  "v3.projet.equipe.introuvable": "Team not found.",
  "v3.projet.equipe.membres": "Team members",
  "v3.projet.equipe.nom": "Team name",
  "v3.projet.equipe.retirer": "Remove {{nom}} from the team",
  "v3.projet.equipe.sans_cadence": "No active cadence for this team.",
  "v3.projet.equipe.supprimer": "Delete the team",
  "v3.projet.equipe.supprimer_titre": "Delete a team — confirmation",
  "v3.projet.equipe.tous_les_membres": "All project members",
  "v3.projet.equipe.travail": "Assigned work",
  "v3.projet.etape.a_venir": "upcoming",
  "v3.projet.etape.en_cours": "in progress",
  "v3.projet.etape.faite": "done",
  "v3.projet.etape.franchie": "passed",
  "v3.projet.etape.non_activee": "not enabled",
  "v3.projet.etape.rouverte": "reopened",
  "v3.projet.etat.chargement": "Loading {{quoi}}…",
  "v3.projet.etat.erreur": "{{quoi}}: cannot be read right now.",
  "v3.projet.etat.reessayer": "Retry",
  "v3.projet.etat.refus": "{{quoi}}: you do not have access to this information.",
  "v3.projet.export.aucun": "No governed export.",
  "v3.projet.export.auteur": "Author",
  "v3.projet.export.contenu": "Exported content",
  "v3.projet.export.demande": "Governed export requested.",
  "v3.projet.export.demander": "Request a governed export",
  "v3.projet.export.empreinte": "Fingerprint",
  "v3.projet.export.espace": "Full project archive",
  "v3.projet.export.espace_aide": "Downloads the whole project, as an owner backup.",
  "v3.projet.export.etat": "State",
  "v3.projet.export.etat_active": "active",
  "v3.projet.export.etat_expired": "expired",
  "v3.projet.export.exclusions": "Exclusions: {{liste}}",
  "v3.projet.export.expire_le": "expires on {{date}}",
  "v3.projet.export.exporter": "Export the workspace",
  "v3.projet.export.fiche": "Governed export details",
  "v3.projet.export.finalite": "Purpose",
  "v3.projet.export.finalite_partage_pseudonymise": "Pseudonymised sharing",
  "v3.projet.export.finalite_sauvegarde_proprietaire": "Owner backup",
  "v3.projet.export.gouverne": "Governed exports",
  "v3.projet.export.heures": "{{n}} hours",
  "v3.projet.export.lien_depuis_fiche": "The single-use link is issued from the export details.",
  "v3.projet.export.lien_emis": "Single-use link issued.",
  "v3.projet.export.liens": "Links",
  "v3.projet.export.liens_valeur": "{{emis}} issued, {{utilises}} used",
  "v3.projet.export.numero": "Export no. {{id}}",
  "v3.projet.export.perimetre": "Audience (v10 rights)",
  "v3.projet.export.provenance": "Provenance",
  "v3.projet.export.public": "Audience",
  "v3.projet.export.public_contributor": "Contributors",
  "v3.projet.export.public_owner": "Owners",
  "v3.projet.export.public_viewer": "Viewers",
  "v3.projet.export.retention": "Retention",
  "v3.projet.export.retour": "Back to exports",
  "v3.projet.export.signature": "Signature",
  "v3.projet.export.telecharge": "Archive downloaded.",
  "v3.projet.export.telecharge_le": "downloaded on {{date}}",
  "v3.projet.export.telecharger": "Download",
  "v3.projet.export.telecharger_depuis_fiche": "Download from the export details, with a single-use link.",
  "v3.projet.export.titre": "Project export",
  "v3.projet.geste.enregistre": "Change saved.",
  "v3.projet.geste.erreur": "The action did not complete. Try again in a moment.",
  "v3.projet.indicateurs.aucune_tranche": "No slice ready.",
  "v3.projet.indicateurs.budget_erreur": "Error budget",
  "v3.projet.indicateurs.choisir_tranche": "Choose a slice to see its details.",
  "v3.projet.indicateurs.consommation": "AI consumption",
  "v3.projet.indicateurs.delai": "Lead time",
  "v3.projet.indicateurs.detail": "Signal detail",
  "v3.projet.indicateurs.detail_signaux": "A signal’s details are read in its block, with no new call.",
  "v3.projet.indicateurs.efficacite": "Agent efficiency",
  "v3.projet.indicateurs.jours": "{{n}} days",
  "v3.projet.indicateurs.mesure": "Measure",
  "v3.projet.indicateurs.obstacles": "Cadence obstacles",
  "v3.projet.indicateurs.periode": "Period",
  "v3.projet.indicateurs.reessayer_bloc": "Each failed block is re-read on its own with its Retry button.",
  "v3.projet.indicateurs.sante": "Computed project health",
  "v3.projet.indicateurs.seuils": "Thresholds: {{liste}}",
  "v3.projet.indicateurs.signal": "Signal",
  "v3.projet.indicateurs.statistiques": "Backlog statistics",
  "v3.projet.indicateurs.tableau": "Show as a table",
  "v3.projet.indicateurs.tableau_de_bord": "Dashboard",
  "v3.projet.indicateurs.titre": "Project indicators",
  "v3.projet.indicateurs.tranche_choisie": "Selected slice",
  "v3.projet.indicateurs.tranches": "Slices ready to build",
  "v3.projet.indicateurs.valeur": "Value",
  "v3.projet.indicateurs.vide": "No data for this block.",
  "v3.projet.integrations.activer_webhook": "Enable {{nom}}",
  "v3.projet.integrations.actualiser": "Refresh the data",
  "v3.projet.integrations.aucun_webhook": "No public webhook.",
  "v3.projet.integrations.branches": "Branches",
  "v3.projet.integrations.connecter": "Connect",
  "v3.projet.integrations.connecter_odoo": "Connect Odoo",
  "v3.projet.integrations.creer_partenaire": "Create a partner",
  "v3.projet.integrations.creer_webhook": "Create a webhook",
  "v3.projet.integrations.declencher": "Triggering a pipeline belongs to the release manager, never to integrations.",
  "v3.projet.integrations.depot": "GitLab repository",
  "v3.projet.integrations.depot_absent": "No repository connected.",
  "v3.projet.integrations.depot_connecte": "Connected to {{url}} (project {{depot}}).",
  "v3.projet.integrations.desactiver": "Disable",
  "v3.projet.integrations.desactiver_effet": "Received events will no longer trigger anything.",
  "v3.projet.integrations.desactiver_webhook": "Disable {{nom}}",
  "v3.projet.integrations.etapes": "Pipeline #{{id}} jobs",
  "v3.projet.integrations.evenements": "{{n}} events received, last: {{dernier}}",
  "v3.projet.integrations.fusions": "Merge requests",
  "v3.projet.integrations.https": "The address must start with https://",
  "v3.projet.integrations.injoignable": "Connection unreachable: {{motif}}",
  "v3.projet.integrations.jeton": "Access token",
  "v3.projet.integrations.jeton_aide": "Optional for a public project; never shown again.",
  "v3.projet.integrations.joignable": "Connection reachable.",
  "v3.projet.integrations.liste_sans_depot": "Read once a repository is connected.",
  "v3.projet.integrations.liste_vide": "Nothing to show.",
  "v3.projet.integrations.odoo": "Odoo",
  "v3.projet.integrations.odoo_absent": "Odoo is not connected.",
  "v3.projet.integrations.odoo_base": "Odoo database",
  "v3.projet.integrations.odoo_instance": "Odoo instance",
  "v3.projet.integrations.odoo_login": "Odoo login",
  "v3.projet.integrations.odoo_secret": "Odoo password",
  "v3.projet.integrations.partenaire": "Partner name",
  "v3.projet.integrations.pipelines": "Recent pipelines",
  "v3.projet.integrations.projet_depot": "Repository project",
  "v3.projet.integrations.supprimer": "Delete the connection",
  "v3.projet.integrations.supprimer_effet": "Pipelines, merge requests and branches will no longer be read.",
  "v3.projet.integrations.tester": "Test the connection",
  "v3.projet.integrations.tester_odoo": "Test Odoo",
  "v3.projet.integrations.trace": "Job trace",
  "v3.projet.integrations.trace_masquee": "Choose a job to expand its trace.",
  "v3.projet.integrations.url": "Instance address",
  "v3.projet.integrations.webhooks": "Public webhooks",
  "v3.projet.methode.artefacts": "Artefact types",
  "v3.projet.methode.deroule": "Model flow",
  "v3.projet.methode.lancer": "Start a process",
  "v3.projet.methode.modele": "Workspace model",
  "v3.projet.methode.objets": "Object chain",
  "v3.projet.methode.sans_modele": "This project has no frozen model: no flow to show.",
  "v3.projet.methode.titre": "Project view — method and process",
  "v3.projet.methode.workflows": "Workflows and agent roles",
  "v3.projet.modele.aucun": "No frozen model for this project.",
  "v3.projet.modele.fige": "Model {{modele}}, version {{version}}, frozen when the project was created.",
  "v3.projet.modele.jamais_migre": "A project never changes model: a new project does.",
  "v3.projet.modeles.a_autoriser": "Model to allow",
  "v3.projet.modeles.agent_autorise": "allowed in the project",
  "v3.projet.modeles.agent_non_autorise": "not allowed",
  "v3.projet.modeles.agents": "Organisation agents",
  "v3.projet.modeles.aucun_agent": "No agent in the organisation.",
  "v3.projet.modeles.autoriser": "Allow this model",
  "v3.projet.modeles.autoriser_agent": "Allow agent {{nom}}",
  "v3.projet.modeles.retirer": "Remove model {{nom}}",
  "v3.projet.modeles.retirer_agent": "Remove agent {{nom}}",
  "v3.projet.modeles.retirer_effet": "{{n}} project agents use this model and will need another one.",
  "v3.projet.modeles.titre": "Allowed models",
  "v3.projet.modeles.utilise_par": "Used by {{n}} agents",
  "v3.projet.modeles.vide": "No model is allowed in this project.",
  "v3.projet.motif": "Reason",
  "v3.projet.nature.access_request_to_decide": "Pending access request",
  "v3.projet.nature.designation_missing": "Required designation missing",
  "v3.projet.nature.launch_to_finish": "Launch to finish",
  "v3.projet.nature.quota_over_threshold": "Quota above 80%",
  "v3.projet.nature.technology_change_to_decide": "Technology change to decide",
  "v3.projet.nature.waiver_to_review": "Waiver to review",
  "v3.projet.onglet.activite": "Activity",
  "v3.projet.onglet.apercu": "Overview",
  "v3.projet.onglet.configuration": "Configuration",
  "v3.projet.onglet.cycle": "Lifecycle",
  "v3.projet.onglet.indicateurs": "Indicators",
  "v3.projet.onglet.integrations": "Integrations",
  "v3.projet.onglet.membres": "Members",
  "v3.projet.onglet.methode": "Method and process",
  "v3.projet.onglet.modeles": "Allowed models and agents",
  "v3.projet.onglet.quotas": "Quotas",
  "v3.projet.onglets.reglages": "Project settings sections",
  "v3.projet.onglets.vue": "Project views",
  "v3.projet.options.membres": "Project members",
  "v3.projet.quotas.avertissement": "above 80%",
  "v3.projet.quotas.bloquees": "Generations are blocked: a limit has been reached.",
  "v3.projet.quotas.enregistrer": "Save the limit",
  "v3.projet.quotas.limite": "Limit",
  "v3.projet.quotas.par_consommation": "Usage",
  "v3.projet.quotas.par_ressource": "Resource",
  "v3.projet.quotas.plafond": "organisation ceiling {{n}}",
  "v3.projet.quotas.remettre": "Reset to zero",
  "v3.projet.quotas.remettre_effet": "The resource usage starts again from zero.",
  "v3.projet.quotas.ressource.document_size_mb": "Document size (MiB)",
  "v3.projet.quotas.ressource.documents_count": "Number of documents",
  "v3.projet.quotas.ressource.generations": "Generations",
  "v3.projet.quotas.ressource.requests_per_minute": "Requests per minute",
  "v3.projet.quotas.ressource.storage": "Storage",
  "v3.projet.quotas.ressource.tokens": "Tokens",
  "v3.projet.quotas.ressource.tokens_per_day": "Tokens per day",
  "v3.projet.quotas.ressource_choisie": "Resource",
  "v3.projet.quotas.retirer": "Remove the limit",
  "v3.projet.quotas.retirer_effet": "The resource will no longer have a project-specific limit.",
  "v3.projet.quotas.titre": "Project quotas",
  "v3.projet.quotas.trier": "Sort by",
  "v3.projet.quotas.vide": "No quota for this project.",
  "v3.projet.referentiel.absente": "Missing rules: {{codes}}",
  "v3.projet.referentiel.ajouter": "Add a rule",
  "v3.projet.referentiel.appliquer": "Enforce",
  "v3.projet.referentiel.appliquer_mode": "Apply the mode",
  "v3.projet.referentiel.appliquer_verbe": "Apply",
  "v3.projet.referentiel.approuver": "Approve the review",
  "v3.projet.referentiel.aucune_derogation": "No waiver.",
  "v3.projet.referentiel.aucune_regle": "No rule applies to this project.",
  "v3.projet.referentiel.choisir_derogation": "Choose a waiver to see its details.",
  "v3.projet.referentiel.choisir_regle": "Choose a rule to see its details.",
  "v3.projet.referentiel.commentaire": "Review comment",
  "v3.projet.referentiel.contenu": "Content to check",
  "v3.projet.referentiel.decision_organisation": "The decision on a waiver belongs to the organisation.",
  "v3.projet.referentiel.demander_derogation": "Request a waiver",
  "v3.projet.referentiel.derogation.expired": "expired",
  "v3.projet.referentiel.derogation.granted": "granted",
  "v3.projet.referentiel.derogation.lifted": "lifted",
  "v3.projet.referentiel.derogation.refused": "refused",
  "v3.projet.referentiel.derogation.requested": "requested",
  "v3.projet.referentiel.derogation_detail": "Risk {{risque}} · controls: {{mesures}} · expires {{echeance}} · requested by {{auteur}}",
  "v3.projet.referentiel.derogations": "Project waivers",
  "v3.projet.referentiel.detail": "Category {{categorie}} · control {{controle}} · owner {{proprietaire}}",
  "v3.projet.referentiel.deux_personnes": "Two-person mode",
  "v3.projet.referentiel.deux_personnes_actif": "Two-person mode on: a second person validates items of risk {{risque}} and above.",
  "v3.projet.referentiel.deux_personnes_inactif": "Two-person mode off.",
  "v3.projet.referentiel.effet_enforce": "A missing rule will block project deliverables.",
  "v3.projet.referentiel.effet_observe": "Missing rules will be reported without blocking (never weaker than the organisation).",
  "v3.projet.referentiel.etat.a_verifier": "to check",
  "v3.projet.referentiel.etat.conforme": "compliant",
  "v3.projet.referentiel.etat.en_derogation": "waived",
  "v3.projet.referentiel.etat.non_conforme": "non-compliant",
  "v3.projet.referentiel.etat.perimee": "outdated",
  "v3.projet.referentiel.fiche_derogation": "Waiver details",
  "v3.projet.referentiel.fiche_regle": "Rule details",
  "v3.projet.referentiel.heritee": "inherited",
  "v3.projet.referentiel.mode": "Enforcement mode",
  "v3.projet.referentiel.observer": "Observe",
  "v3.projet.referentiel.presente": "All rules are present.",
  "v3.projet.referentiel.propre": "project-specific",
  "v3.projet.referentiel.regles": "Rules",
  "v3.projet.referentiel.rejeter": "Reject",
  "v3.projet.referentiel.relue": "Review recorded: the organisation will decide.",
  "v3.projet.referentiel.relue_par": "Reviewed by {{qui}}",
  "v3.projet.referentiel.retirer": "Remove the rule from the project",
  "v3.projet.referentiel.retirer_effet": "Rule {{code}} will no longer apply to this project.",
  "v3.projet.referentiel.titre": "Project inherited requirements",
  "v3.projet.referentiel.verifier": "Check presence",
  "v3.projet.reglages.charte": "Project charter",
  "v3.projet.reglages.description": "Description",
  "v3.projet.reglages.enregistre": "Change saved.",
  "v3.projet.reglages.enregistrer": "Save",
  "v3.projet.reglages.gouvernance": "Project governance",
  "v3.projet.reglages.identite": "Project identity",
  "v3.projet.reglages.methode": "Method and process",
  "v3.projet.reglages.modele": "Project model",
  "v3.projet.reglages.nom": "Project name",
  "v3.projet.reglages.nom_validation": "Between 3 and 255 characters.",
  "v3.projet.reglages.renommer": "Rename",
  "v3.projet.reglages.rien_a_enregistrer": "Nothing to save: no value changed.",
  "v3.projet.reglages.sections": "Available sections",
  "v3.projet.reglages.sections_aide": "Each section opens to whoever can act in it; each command checks its right.",
  "v3.projet.reglages.titre": "Project settings",
  "v3.projet.regle.ajouter": "Add the rule",
  "v3.projet.regle.ajouter_critere": "Add as a definition of done",
  "v3.projet.regle.categorie": "Category",
  "v3.projet.regle.critere": "Criterion (threshold, optional)",
  "v3.projet.regle.enonce": "Statement",
  "v3.projet.regle.identifiant": "Identifier",
  "v3.projet.regle.preuve": "Means of proof",
  "v3.projet.regle.proprietaire": "Owner",
  "v3.projet.regle.titre": "Add a project-specific rule",
  "v3.projet.retirer": "Remove",
  "v3.projet.retour_vue": "Back to the project overview",
  "v3.projet.sans_projet": "First choose a project in the context bar.",
  "v3.projet.sante.a_risque": "At risk",
  "v3.projet.sante.en_bonne_voie": "On track",
  "v3.projet.sante.hors_trajectoire": "Off track",
  "v3.projet.sante.indicateur": "Health indicator",
  "v3.projet.sante.publier": "Publish",
  "v3.projet.sante.texte": "Update text",
  "v3.projet.sante.titre": "Publish project health",
  "v3.projet.suppression.effet_differee": "The organisation decides and schedules a deferred deletion.",
  "v3.projet.suppression.effet_export": "Export the project first if you want to keep a copy.",
  "v3.projet.suppression.envoyer": "Send the request",
  "v3.projet.suppression.motif_validation": "At least 15 characters.",
  "v3.projet.suppression.titre": "Project deletion by the organisation — request",
  "v3.projet.supprimer": "Delete",
  "v3.projet.surcharge.demander": "Request the waiver",
  "v3.projet.surcharge.ecarts": "Deviations from the charter",
  "v3.projet.surcharge.suite": "Recommended charter: the override is recorded. Enforced charter: the organisation decides.",
  "v3.projet.surcharge.titre": "Request a charter override",
  "v3.projet.vue.a_traiter": "Waiting for the owner",
  "v3.projet.vue.accepter_rattachement": "Accept the attachment",
  "v3.projet.vue.activite": "Recent activity",
  "v3.projet.vue.application_a_recetter": "Application to accept",
  "v3.projet.vue.aucun_indicateur": "No indicator available.",
  "v3.projet.vue.aucun_proprietaire": "No named owner",
  "v3.projet.vue.aucun_rattachement": "No attachment proposed.",
  "v3.projet.vue.aucune_activite": "No recent activity.",
  "v3.projet.vue.aucune_etape": "No step in the lifecycle.",
  "v3.projet.vue.aucune_sante": "No health update published.",
  "v3.projet.vue.comprendre": "Understand a refusal and request access",
  "v3.projet.vue.cycle": "Lifecycle progress",
  "v3.projet.vue.decider_acces": "Decide the access requests",
  "v3.projet.vue.description": "Description",
  "v3.projet.vue.droits_gagnes": "The programme would gain: {{droits}}",
  "v3.projet.vue.executer_etape": "Run a step",
  "v3.projet.vue.exporter": "Export the project",
  "v3.projet.vue.identite": "Project identity",
  "v3.projet.vue.indicateurs": "Project indicators",
  "v3.projet.vue.motif_refus": "Reason for refusal (optional)",
  "v3.projet.vue.nom": "Name",
  "v3.projet.vue.ouvrir_changements": "Open the changes",
  "v3.projet.vue.ouvrir_reglages": "Open the settings",
  "v3.projet.vue.programme": "Programme",
  "v3.projet.vue.proprietaires": "Owner",
  "v3.projet.vue.publie_par": "Published by {{qui}} on {{date}}",
  "v3.projet.vue.publier_sante": "Publish health",
  "v3.projet.vue.rattachement": "Proposed attachment",
  "v3.projet.vue.rattachement_accepte": "Attachment accepted.",
  "v3.projet.vue.rattachement_propose": "Programme {{programme}} proposes to attach this project (requested by {{demandeur}} on {{date}}).",
  "v3.projet.vue.rattachement_refuse": "Attachment refused.",
  "v3.projet.vue.refuser_rattachement": "Refuse the attachment",
  "v3.projet.vue.rien_a_traiter": "Nothing is waiting for the owner.",
  "v3.projet.vue.sans_description": "No description.",
  "v3.projet.vue.sans_programme": "Not attached to any programme",
  "v3.projet.vue.sante": "Published health",
  "v3.projet.vue.suppression_programmee": "Deletion scheduled by the organisation: purge after {{date}}.",
  "v3.projet.vue.terminer_lancement": "Finish the launch",
  "v3.projet.vue.titre": "Project overview",
  "v3.projet.webhook.copie": "I copied the secret",
  "v3.projet.webhook.copier": "Copy the address",
  "v3.projet.webhook.creer": "Create the webhook",
  "v3.projet.webhook.nom": "Name",
  "v3.projet.webhook.secret_une_fois": "Webhook secret, shown only once: copy it now.",
  "v3.projet.webhook.titre": "Create a public project webhook",
  "v3.projet.webhook.type": "Event type",
  "v3.projet.webhook.type_generic": "Generic",
  "v3.projet.webhook.type_gitlab_merge_request": "GitLab merge request",
  "v3.projet.webhook.type_gitlab_pipeline": "GitLab pipeline",
  "v3.projet.webhook.type_gitlab_push": "GitLab push",
  "v3.projet.webhook.workflow": "Triggered workflow (optional)"
}
